import { useContext } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import { MockedAuthContext } from 'src/Providers/Auth/mockedAuth';

export const useAuth =
  process.env.REACT_APP_DISABLE_AUTH === 'true' ? () => useContext(MockedAuthContext) : useAuth0;
